define.alias("shared/components/shared/post-tagging/badge", "media/components/shared/post-tagging/badge");